import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import store from './store'
import domReady from '../../utils/domReady.js'

Vue.config.productionTip = false

Vue.use(Vuex)
domReady(() => {
  const el = document.querySelector('#events-viewer')
  if (el !== null) {
    const vm = new Vue({
      render: h => h(App),
      store: new Vuex.Store(store)
    })
    vm.$mount(el)
  }
})
